import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=e03ffbea&scoped=true"
import script from "./Columns.vue?vue&type=script&lang=js"
export * from "./Columns.vue?vue&type=script&lang=js"
import style0 from "./Columns.vue?vue&type=style&index=0&id=e03ffbea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03ffbea",
  null
  
)

export default component.exports